import React from 'react';
import { Box } from '@mui/joy';
import Footer from './Footer';
import AppLayout from './Navigation';

const PageShell = ({ withNav = false, children }) => {
  if (withNav) {
    return <AppLayout>{children}</AppLayout>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box component="main" sx={{ flex: 1, display: 'flex', flexDirection: 'column', pb: { xs: 0, md: '5px' } }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default PageShell;
